"use client"

import axios from "axios";
import { clearToken } from "./tokenUtil";

let store= null;

export const injectStore = (_store) => {
    store = _store;
};

const defaultBaseUrl = "https://dc.dokless.com/api/";

const API = axios.create({
    baseURL: defaultBaseUrl,
    responseType: "json",
    timeout: 20000,
    headers: {
        "Content-Type": "application/json"
        // "X-Accept-Version": version
        // "X-Api-Key": "hkjdIYlm8FnMEcJyt6km2Jx8ErtOiF8tk",
    },
});
//
// API.interceptors.request.use(async function (req) {
//     if (store && store.getState().auth.token !== null) {
//         req.headers = {
//             ...req.headers,
//             Authorization: `Bearer ${store.getState().auth.token}`,
//         };
//     }
//
//     return req;
// });

API.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error.response) {
            let status = 0;
            let message = "";
            let required_action = null;
            if (error.response.data != null) {
                status = error.response.data.code || 0;
                required_action = error.response.data.required_action || null;
                message = error.response.data.message || "";
                if (error.response.data.validation != null) {
                    message = error.response.data.validation[0];
                }
            }

            if (store && store.getState().auth.token && status === 401) {
                clearToken();
                localStorage.clear();
                window.location.reload();
            }

            return Promise.reject({ code: status, message: message, required_action: required_action });
        } else if (error.request) {
            // Handle request errors
        } else if (error.message) {
            return Promise.reject({ code: 0, message: "Request Canceled" });
        }
    }
);

export default API;

export function sendMedia(url, response, uri) {
    const formData = new FormData();
    //formData.append("Acl", response.acl);
    formData.append("Content-Type", response["content-type"]);
    formData.append("Key", response.key);
    formData.append("X-Amz-Credential", response["X-Amz-Credential"]);
    formData.append("X-Amz-Algorithm", response["X-Amz-Algorithm"]);
    formData.append("X-Amz-Date", response["X-Amz-Date"]);
    formData.append("Policy", response.Policy);
    formData.append("X-Amz-Signature", response["X-Amz-Signature"]);
    formData.append("file", uri);

    return axios.post(url, formData);
}

export const deleteElement = (endpoint) => API.delete(endpoint);
export const putElement = (endpoint, data = false) => API.put(endpoint, data ? data : {});
export const postElement = (endpoint, data = {}, signal = false) => API.post(endpoint, data ? data : {}, signal && {signal: signal});
export const getElement = (endpoint, signal = false) => API.get(endpoint, signal && {signal: signal});
export const getElementParams = (endpoint, params = false, signal = false) => API.get(endpoint + ( params ? serialize(params) : ''), signal && {signal: signal});

export const getSignedRequests = ({ params }) =>
    API.post('/media/signed_requests' + (params ? serialize(params) : ""));




export function serialize(data) {
    if (typeof data != "object") {
        return "?" + data;
    }
    var str = [];
    for (var p in data) {
        if (data[p] && data.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
        }
    }
    return "?" + str.join("&");
}



//export const getElement = (endpoint: string, signal = null, params = null) => API.get(endpoint + (params ? serialize(params) : ''), signal ? { signal: signal } : {});
//export const getElementBody = (endpoint: string, signal = null, params = null, data = false) => API.post(endpoint + (params ? serialize(params) : ''), data ? data : {}, signal ? { signal: signal } : {});

